var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 11.6382 3.31535 15 7.39644 15C9.38314 15 11.1917 14.1999 12.5232 12.8999C12.528 12.9052 12.533 12.9104 12.5381 12.9156L19.237 19.8668C19.3168 19.9557 19.4321 20.0001 19.5475 20.0001C19.6628 20.0001 19.7693 19.9557 19.8669 19.8668C20.0444 19.689 20.0444 19.4134 19.8669 19.2356L13.1681 12.2845C13.153 12.2694 13.1373 12.2556 13.1209 12.2431C14.1651 10.9501 14.7929 9.29839 14.7929 7.5C14.7929 3.36176 11.4775 0 7.39644 0C3.31535 0 0 3.36176 0 7.5ZM0.87017 7.5C0.87017 3.84706 3.79394 0.882353 7.39644 0.882353C10.9902 0.882353 13.9227 3.84706 13.9227 7.5C13.9227 11.1529 10.9989 14.1176 7.39644 14.1176C3.79394 14.1176 0.87017 11.1529 0.87017 7.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0987f28d863339eef14eaa90e50ff735.svg";
export { ForwardRef as ReactComponent };